import { http } from '@/network/http';
import type {
  FeedResponse,
  PostDetailResponse,
  CommentsResponse,
  RepliesResponse,
  CreatePostData,
  UpdatePostData,
  CreateCommentData,
  FeedPost,
  PostComment,
  TaggableUser,
  UserProfileResponse,
} from './types';

export const feedApi = {
  getFeed: (cursor?: string, limit?: number) =>
    http.get<FeedResponse>('/feed', {
      params: { cursor, limit },
    }),

  getPost: (id: string) =>
    http.get<PostDetailResponse>(`/feed/${id}`),

  createPost: (data: CreatePostData) =>
    http.post<{ success: boolean; post: FeedPost }>('/feed', data),

  updatePost: (id: string, data: UpdatePostData) =>
    http.put<{ success: boolean; post: FeedPost }>(`/feed/${id}`, data),

  deletePost: (id: string) =>
    http.delete<{ success: boolean }>(`/feed/${id}`),

  togglePin: (id: string) =>
    http.post<{ success: boolean; isPinned: boolean }>(`/feed/${id}/pin`),

  toggleReaction: (postId: string, type: string) =>
    http.post<{ success: boolean; action: 'added' | 'removed'; type: string }>(
      `/feed/${postId}/reactions`,
      { type }
    ),

  getComments: (postId: string, cursor?: string, limit?: number) =>
    http.get<CommentsResponse>(`/feed/${postId}/comments`, {
      params: { cursor, limit },
    }),

  getReplies: (postId: string, commentId: string, cursor?: string, limit?: number) =>
    http.get<RepliesResponse>(`/feed/${postId}/comments/${commentId}/replies`, {
      params: { cursor, limit },
    }),

  addComment: (postId: string, data: CreateCommentData) =>
    http.post<{ success: boolean; comment: PostComment }>(
      `/feed/${postId}/comments`,
      data
    ),

  editComment: (postId: string, commentId: string, content: string) =>
    http.put<{ success: boolean; comment: PostComment }>(
      `/feed/${postId}/comments/${commentId}`,
      { content }
    ),

  deleteComment: (postId: string, commentId: string) =>
    http.delete<{ success: boolean }>(`/feed/${postId}/comments/${commentId}`),

  recordView: (postId: string) =>
    http.post<{ success: boolean }>(`/feed/${postId}/views`),

  getUserSuggestions: (search?: string) =>
    http.get<{ success: boolean; users: TaggableUser[] }>('/feed/users/suggestions', {
      params: { search },
    }),

  getUserProfile: (userId: string) =>
    http.get<UserProfileResponse>(`/feed/users/${userId}/profile`),
};
